export default __webpack_public_path__ + "static/thomas-aa5b8e9f374fc0d14f7a88e68435cc63.png";